import type { JSX } from 'react';
import { Box, List } from '@ksyos/design-system';
import { useTheme } from 'styled-components';
import type {
    IStepCount,
    IStepGroup,
    OutclinicDashboardServiceCode,
} from '@common/interfaces/api/outclinicDashboardApi';
import { OutclinicDashboardStepFilterItem } from './OutclinicDashboardStepFilterItem';

interface IOutclinicDashboardStepFilterSideProps {
    activeDashboardStepIdentifier: string | null;
    counts: IStepCount[];
    groups: IStepGroup[];
    onChange: (dashboardStepIdentifier: string) => void;
    serviceCode: OutclinicDashboardServiceCode;
}

export function OutclinicDashboardStepFiltersSide(
    props: Readonly<IOutclinicDashboardStepFilterSideProps>
): JSX.Element {
    const theme = useTheme();

    return (
        <Box flex={[0, `0 0 ${theme.space[48]}`, `0 0 ${theme.space[72]}`]}>
            <List>
                {props.groups.map((group) => (
                    <OutclinicDashboardStepFilterItem
                        activeDashboardStepIdentifier={props.activeDashboardStepIdentifier}
                        counts={props.counts}
                        key={group.title}
                        onChange={props.onChange}
                        steps={group.steps}
                        title={group.title}
                    />
                ))}
            </List>
        </Box>
    );
}
